// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Container,
//   IconButton,
//   Tooltip,
//   Snackbar,
//   Alert,
//   Menu,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   TextField,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import axios from "axios";
// import Swal from 'sweetalert2';

// const InvestorApproval = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "success" });
//   const [dialog, setDialog] = useState({ open: false, type: "", rowIds: [] });
//   const [filters, setFilters] = useState({ name: "", email: "", role: "" });

//   // Fetch data from API and filter only admin_approval: false
//   const fetchData = async () => {
//     try {
//       const response = await axios.get("https://newbackend.elephant-tank.com/api/investor_data/", {
//         headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//       });

//       // Filter for admin_approval: false
//       const filteredData = response.data.filter((investor) => !investor.admin_approval);
//       setData(filteredData);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   // Handle Dialog Actions
//   const handleDialogOpen = (type, rowIds) => setDialog({ open: true, type, rowIds });
//   const handleDialogClose = () => setDialog({ open: false, type: "", rowIds: [] });
//   // const handleAction = async (action) => {
//   //   try {
//   //     const { rowIds } = dialog;
  
//   //     // Construct the payload
//   //     const payload = {
//   //       ivestors: rowIds,
//   //     };
  
//   //     // Approve or deny the investors
//   //     await axios.post("https://newbackend.elephant-tank.com/api/approve_investor/", payload, {
//   //       headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//   //     });
  
//   //     // Show success SweetAlert
//   //     Swal.fire({
//   //       title: `Investors ${action}ed & approved successfully and mail sent to Investors .`,
//   //       icon: 'success',
//   //       confirmButtonText: 'OK',
//   //     });
  
//   //     // Refetch data after approval or denial
//   //     fetchData();
//   //   } catch (error) {
//   //     console.error(`Error ${dialog.type}ing investors:`, error);
  
//   //     // Show error SweetAlert
//   //     Swal.fire({
//   //       title: `Failed to ${dialog.type} investors`,
//   //       icon: 'error',
//   //       confirmButtonText: 'OK',
//   //     });
//   //   } finally {
//   //     handleDialogClose();
//   //   }
//   // };
  
//   // const handleAction = async (action) => {
//   //   try {
//   //     const { rowIds } = dialog;

//   //     // Construct the payload
//   //     const payload = {
//   //       ivestors: rowIds,
//   //     };

//   //     // Approve or deny the investors
//   //     await axios.post("https://newbackend.elephant-tank.com/api/approve_investor/", payload, {
//   //       headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//   //     });

//   //     // Show success message
//   //     setSnackbar({
//   //       open: true,
//   //       message: `Investors ${action}ed successfully`,
//   //       type: "success",
//   //     });

//   //     // Refetch data after approval or denial
//   //     fetchData();
//   //   } catch (error) {
//   //     console.error(`Error ${dialog.type}ing investors:`, error);

//   //     // Show error message
//   //     setSnackbar({
//   //       open: true,
//   //       message: `Failed to ${dialog.type} investors`,
//   //       type: "error",
//   //     });
//   //   } finally {
//   //     handleDialogClose();
//   //   }
//   // };

//   // Handle Filters
//   const handleAction = async (action) => {
//     try {
//       const { rowIds } = dialog;
  
//       // Construct the payload
//       const payload = {
//         ivestors: rowIds,
//       };
  
//       // Approve or deny the investors
//       await axios.post("https://newbackend.elephant-tank.com/api/approve_investor/", payload, {
//         headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//       });
  
//       // Show success SweetAlert
//       Swal.fire({
//         title: `Investors ${action}ed successfully and mail sent to investors.`,
//         icon: 'success',
//         confirmButtonText: 'OK',
//       });
  
//       // Refetch data after approval or denial
//       fetchData();
//     } catch (error) {
//       console.error(`Error ${dialog.type}ing investors:`, error);
  
//       // Check if the error contains OTP verification details
//       if (error.response && error.response.data && error.response.data.msg) {
//         // Extract the unverified investor ID from the error message
//         const unverifiedId = error.response.data.msg.match(/\d+/)?.[0]; // Extract the ID (if present)
//         const unverifiedInvestor = data.find((investor) => investor.id.toString() === unverifiedId);
  
//         Swal.fire({
//           title: 'Action Failed',
//           text: unverifiedInvestor
//             ? `${unverifiedInvestor.full_name} has not been verified via OTP.`
//             : 'One or more investors have not been verified via OTP.',
//           icon: 'warning',
//           confirmButtonText: 'OK',
//         });
//       } else {
//         // General error SweetAlert
//         Swal.fire({
//           title: `Failed to ${dialog.type} investors`,
//           icon: 'error',
//           confirmButtonText: 'OK',
//         });
//       }
//     } finally {
//       handleDialogClose();
//     }
//   };
  
  
//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   const filteredData = data.filter((investor) => {
//     return (
//       investor.full_name.toLowerCase().includes(filters.name.toLowerCase()) &&
//       investor.email.toLowerCase().includes(filters.email.toLowerCase()) &&
//       investor.role.toLowerCase().includes(filters.role.toLowerCase())
//     );
//   });

//   // Columns for DataGrid
//   const columns = [
//     { field: "full_name", headerName: "Name", width: 150 },
//     { field: "email", headerName: "Email", width: 200 },
//     { field: "role", headerName: "Role", width: 150 },
//     { field: "organisation", headerName: "Organisation", width: 180 },
//     {
//       field: "actions",
//       headerName: "Actions",
//       width: 120,
//       renderCell: (params) => (
//         <Box>
//           <Tooltip title="Accept">
//             <IconButton onClick={() => handleDialogOpen("accept", [params.row.id])}>
//               ✅
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Deny">
//             <IconButton onClick={() => handleDialogOpen("deny", [params.row.id])}>
//               ❌
//             </IconButton>
//           </Tooltip>
//         </Box>
//       ),
//     },
//   ];

//   return (
//     <Container sx={{ mt: 10 }}>
//     <Box sx={{ my: 4 }}>
//       <Typography variant="h4" align="center">
//        Investors Approval
//       </Typography>
//     </Box>

//       <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//         <TextField
//           label="Filter by Name"
//           name="name"
//           value={filters.name}
//           onChange={handleFilterChange}
//           variant="outlined"
//         />
//         <TextField
//           label="Filter by Email"
//           name="email"
//           value={filters.email}
//           onChange={handleFilterChange}
//           variant="outlined"
//         />
//         <TextField
//           label="Filter by Role"
//           name="role"
//           value={filters.role}
//           onChange={handleFilterChange}
//           variant="outlined"
//         />
//       </Box>

//       <Box sx={{ height: 400 }}>
//         <DataGrid
//           rows={filteredData}
//           columns={columns}
//           pageSize={5}
//           rowsPerPageOptions={[5, 10, 20]}
//           loading={loading}
//           checkboxSelection
//           disableSelectionOnClick
//           onSelectionModelChange={(ids) => setSelectedRows(ids)}
//           getRowId={(row) => row.id} // Ensure unique row IDs
//         />
//       </Box>

//       <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => handleDialogOpen("accept", selectedRows)}
//           disabled={selectedRows.length === 0}
//           sx={{ mr: 1 }}
//         >
//           Approve Selected
//         </Button>
//         <Button
//           variant="contained"
//           color="secondary"
//           onClick={() => handleDialogOpen("deny", selectedRows)}
//           disabled={selectedRows.length === 0}
//         >
//           Deny Selected
//         </Button>
//       </Box>

//       <Dialog open={dialog.open} onClose={handleDialogClose}>
//         <DialogTitle>
//           {dialog.type === "accept" ? "Accept Investors" : "Deny Investors"}
//         </DialogTitle>
//         <DialogContent>
//           Are you sure you want to {dialog.type} the selected investors?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDialogClose}>Cancel</Button>
//           <Button onClick={() => handleAction(dialog.type)} color="primary">
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//       >
//         <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.type}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };

// export default InvestorApproval;
// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Container,
//   IconButton,
//   Tooltip,
//   Snackbar,
//   Alert,
//   Menu,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   TextField,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import axios from "axios";
// import Swal from 'sweetalert2';

// const InvestorApproval = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "success" });
//   const [dialog, setDialog] = useState({ open: false, type: "", rowIds: [] });
//   const [filters, setFilters] = useState({ name: "", email: "", role: "" });

//   // Fetch data from API and filter only admin_approval: false
//   const fetchData = async () => {
//     try {
//       const response = await axios.get("https://newbackend.elephant-tank.com/api/investor_data/", {
//         headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//       });

//       // Filter for admin_approval: false
//       const filteredData = response.data.filter((investor) => !investor.admin_approval);
//       setData(filteredData);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   // Handle Dialog Actions
//   const handleDialogOpen = (type, rowIds) => setDialog({ open: true, type, rowIds });
//   const handleDialogClose = () => setDialog({ open: false, type: "", rowIds: [] });
//   // const handleAction = async (action) => {
//   //   try {
//   //     const { rowIds } = dialog;
  
//   //     // Construct the payload
//   //     const payload = {
//   //       ivestors: rowIds,
//   //     };
  
//   //     // Approve or deny the investors
//   //     await axios.post("https://newbackend.elephant-tank.com/api/approve_investor/", payload, {
//   //       headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//   //     });
  
//   //     // Show success SweetAlert
//   //     Swal.fire({
//   //       title: `Investors ${action}ed & approved successfully and mail sent to Investors .`,
//   //       icon: 'success',
//   //       confirmButtonText: 'OK',
//   //     });
  
//   //     // Refetch data after approval or denial
//   //     fetchData();
//   //   } catch (error) {
//   //     console.error(`Error ${dialog.type}ing investors:`, error);
  
//   //     // Show error SweetAlert
//   //     Swal.fire({
//   //       title: `Failed to ${dialog.type} investors`,
//   //       icon: 'error',
//   //       confirmButtonText: 'OK',
//   //     });
//   //   } finally {
//   //     handleDialogClose();
//   //   }
//   // };
  
//   // const handleAction = async (action) => {
//   //   try {
//   //     const { rowIds } = dialog;

//   //     // Construct the payload
//   //     const payload = {
//   //       ivestors: rowIds,
//   //     };

//   //     // Approve or deny the investors
//   //     await axios.post("https://newbackend.elephant-tank.com/api/approve_investor/", payload, {
//   //       headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//   //     });

//   //     // Show success message
//   //     setSnackbar({
//   //       open: true,
//   //       message: `Investors ${action}ed successfully`,
//   //       type: "success",
//   //     });

//   //     // Refetch data after approval or denial
//   //     fetchData();
//   //   } catch (error) {
//   //     console.error(`Error ${dialog.type}ing investors:`, error);

//   //     // Show error message
//   //     setSnackbar({
//   //       open: true,
//   //       message: `Failed to ${dialog.type} investors`,
//   //       type: "error",
//   //     });
//   //   } finally {
//   //     handleDialogClose();
//   //   }
//   // };

//   // Handle Filters
//   const handleAction = async (action) => {
//     try {
//       const { rowIds } = dialog;
  
//       // Construct the payload
//       const payload = {
//         ivestors: rowIds,
//       };
  
//       // Approve or deny the investors
//       await axios.post("https://newbackend.elephant-tank.com/api/approve_investor/", payload, {
//         headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//       });
  
//       // Show success SweetAlert
//       Swal.fire({
//         title: `Investors ${action}ed successfully and mail sent to investors.`,
//         icon: 'success',
//         confirmButtonText: 'OK',
//       });
  
//       // Refetch data after approval or denial
//       fetchData();
//     } catch (error) {
//       console.error(`Error ${dialog.type}ing investors:`, error);
  
//       // Check if the error contains OTP verification details
//       if (error.response && error.response.data && error.response.data.msg) {
//         // Extract the unverified investor ID from the error message
//         const unverifiedId = error.response.data.msg.match(/\d+/)?.[0]; // Extract the ID (if present)
//         const unverifiedInvestor = data.find((investor) => investor.id.toString() === unverifiedId);
  
//         Swal.fire({
//           title: 'Action Failed',
//           text: unverifiedInvestor
//             ? `${unverifiedInvestor.full_name} has not been verified via OTP.`
//             : 'One or more investors have not been verified via OTP.',
//           icon: 'warning',
//           confirmButtonText: 'OK',
//         });
//       } else {
//         // General error SweetAlert
//         Swal.fire({
//           title: `Failed to ${dialog.type} investors`,
//           icon: 'error',
//           confirmButtonText: 'OK',
//         });
//       }
//     } finally {
//       handleDialogClose();
//     }
//   };
  
  
//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   const filteredData = data.filter((investor) => {
//     return (
//       investor.full_name.toLowerCase().includes(filters.name.toLowerCase()) &&
//       investor.email.toLowerCase().includes(filters.email.toLowerCase()) &&
//       investor.role.toLowerCase().includes(filters.role.toLowerCase())
//     );
//   });

//   // Columns for DataGrid
//   const columns = [
//     { field: "full_name", headerName: "Name", width: 150 },
//     { field: "email", headerName: "Email", width: 200 },
//     { field: "role", headerName: "Role", width: 150 },
//     { field: "organisation", headerName: "Organisation", width: 180 },
//     {
//       field: "actions",
//       headerName: "Actions",
//       width: 120,
//       renderCell: (params) => (
//         <Box>
//           <Tooltip title="Accept">
//             <IconButton onClick={() => handleDialogOpen("accept", [params.row.id])}>
//               ✅
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Deny">
//             <IconButton onClick={() => handleDialogOpen("deny", [params.row.id])}>
//               ❌
//             </IconButton>
//           </Tooltip>
//         </Box>
//       ),
//     },
//   ];

//   return (
//     <Container sx={{ mt: 10 }}>
//     <Box sx={{ my: 4 }}>
//       <Typography variant="h4" align="center">
//        Investors Approval
//       </Typography>
//     </Box>

//       <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//         <TextField
//           label="Filter by Name"
//           name="name"
//           value={filters.name}
//           onChange={handleFilterChange}
//           variant="outlined"
//         />
//         <TextField
//           label="Filter by Email"
//           name="email"
//           value={filters.email}
//           onChange={handleFilterChange}
//           variant="outlined"
//         />
//         <TextField
//           label="Filter by Role"
//           name="role"
//           value={filters.role}
//           onChange={handleFilterChange}
//           variant="outlined"
//         />
//       </Box>

//       <Box sx={{ height: 400 }}>
//         <DataGrid
//           rows={filteredData}
//           columns={columns}
//           pageSize={5}
//           rowsPerPageOptions={[5, 10, 20]}
//           loading={loading}
//           checkboxSelection
//           disableSelectionOnClick
//           onSelectionModelChange={(ids) => setSelectedRows(ids)}
//           getRowId={(row) => row.id} // Ensure unique row IDs
//         />
//       </Box>

//       <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => handleDialogOpen("accept", selectedRows)}
//           disabled={selectedRows.length === 0}
//           sx={{ mr: 1 }}
//         >
//           Approve Selected
//         </Button>
//         <Button
//           variant="contained"
//           color="secondary"
//           onClick={() => handleDialogOpen("deny", selectedRows)}
//           disabled={selectedRows.length === 0}
//         >
//           Deny Selected
//         </Button>
//       </Box>

//       <Dialog open={dialog.open} onClose={handleDialogClose}>
//         <DialogTitle>
//           {dialog.type === "accept" ? "Accept Investors" : "Deny Investors"}
//         </DialogTitle>
//         <DialogContent>
//           Are you sure you want to {dialog.type} the selected investors?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDialogClose}>Cancel</Button>
//           <Button onClick={() => handleAction(dialog.type)} color="primary">
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//       >
//         <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.type}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };

// export default InvestorApproval;

// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Container,
//   IconButton,
//   Tooltip,
//   Snackbar,
//   Alert,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   CircularProgress,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import Swal from "sweetalert2";
// import axios from "axios";

// const InvestorApproval = () => {
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [filters, setFilters] = useState({
//     role: "",
//     organisation: "",
//   });
//   const [filterOptions, setFilterOptions] = useState({
//     roles: [],
//     organisations: [],
//   });
//   const [loading, setLoading] = useState(true);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [dialog, setDialog] = useState({ open: false, type: "", rowIds: [] });
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "success" });

//   // Fetch data and populate filter options
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get("https://newbackend.elephant-tank.com/api/investor_data/", {
//           headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//         });

//         const filteredInvestors = response.data.filter((investor) => !investor.admin_approval);

//         // Extract unique filter options
//         const roles = [...new Set(filteredInvestors.map((item) => item.role))];
//         const organisations = [...new Set(filteredInvestors.map((item) => item.organisation))];

//         setData(filteredInvestors);
//         setFilteredData(filteredInvestors);
//         setFilterOptions({ roles, organisations });
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   // Handle dialog open and close
//   const handleDialogOpen = (type, rowIds) => setDialog({ open: true, type, rowIds });
//   const handleDialogClose = () => setDialog({ open: false, type: "", rowIds: [] });

//   // Handle actions (accept or deny investors)
//   const handleAction = async (action) => {
//     try {
//       const { rowIds } = dialog;

//       const payload = {
//         ivestors: rowIds,
//       };

//       await axios.post(`https://newbackend.elephant-tank.com/api/approve_investor/`, payload, {
//         headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//       });

//       Swal.fire({
//         title: `Investors ${action}ed successfully.`,
//         icon: "success",
//         confirmButtonText: "OK",
//       });

//       // Refetch data after the action
//       const updatedData = data.filter((row) => !rowIds.includes(row.id));
//       setData(updatedData);
//       setFilteredData(updatedData);
//     } catch (error) {
//       console.error(`Error ${action}ing investors:`, error);

//       Swal.fire({
//         title: `Failed to ${action} investors.`,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     } finally {
//       handleDialogClose();
//     }
//   };

//   // Handle filter changes
//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   // Apply filters
//   useEffect(() => {
//     const applyFilters = () => {
//       let filtered = data;

//       if (filters.role) {
//         filtered = filtered.filter((item) => item.role === filters.role);
//       }

//       if (filters.organisation) {
//         filtered = filtered.filter((item) => item.organisation === filters.organisation);
//       }

//       setFilteredData(filtered);
//     };

//     applyFilters();
//   }, [filters, data]);

//   // Columns for DataGrid
//   const columns = [
//     { field: "full_name", headerName: "Name", width: 150 },
//     { field: "email", headerName: "Email", width: 200 },
//     { field: "role", headerName: "Role", width: 150 },
//     { field: "organisation", headerName: "Organisation", width: 180 },
//     {
//       field: "actions",
//       headerName: "Actions",
//       width: 120,
//       renderCell: (params) => (
//         <Box>
//           <Tooltip title="Accept">
//             <IconButton onClick={() => handleDialogOpen("accept", [params.row.id])}>
//               ✅
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Deny">
//             <IconButton onClick={() => handleDialogOpen("deny", [params.row.id])}>
//               ❌
//             </IconButton>
//           </Tooltip>
//         </Box>
//       ),
//     },
//   ];

//   return (
//     <Container sx={{ mt: 10 }}>
//       <Box sx={{ my: 4 }}>
//         <Typography variant="h4" align="center">
//           Investors Approval
//         </Typography>
//       </Box>

//       <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//         <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//           <InputLabel>Role</InputLabel>
//           <Select
//             name="role"
//             value={filters.role}
//             onChange={handleFilterChange}
//             label="Role"
//           >
//             <MenuItem value="">All</MenuItem>
//             {filterOptions.roles.map((role) => (
//               <MenuItem key={role} value={role}>
//                 {role}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//           <InputLabel>Organisation</InputLabel>
//           <Select
//             name="organisation"
//             value={filters.organisation}
//             onChange={handleFilterChange}
//             label="Organisation"
//           >
//             <MenuItem value="">All</MenuItem>
//             {filterOptions.organisations.map((organisation) => (
//               <MenuItem key={organisation} value={organisation}>
//                 {organisation}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Box>

//       <Box sx={{ height: 400 }}>
//         {loading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//             <CircularProgress />
//           </Box>
//         ) : (
//           <DataGrid
//             rows={filteredData}
//             columns={columns}
//             pageSize={5}
//             rowsPerPageOptions={[5, 10, 20]}
//             checkboxSelection
//             disableSelectionOnClick
//             onSelectionModelChange={(ids) => setSelectedRows(ids)}
//             getRowId={(row) => row.id}
//           />
//         )}
//       </Box>

//       <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => handleDialogOpen("accept", selectedRows)}
//           disabled={selectedRows.length === 0}
//           sx={{ mr: 1 }}
//         >
//           Approve Selected
//         </Button>
//         <Button
//           variant="contained"
//           color="secondary"
//           onClick={() => handleDialogOpen("deny", selectedRows)}
//           disabled={selectedRows.length === 0}
//         >
//           Deny Selected
//         </Button>
//       </Box>

//       <Dialog open={dialog.open} onClose={handleDialogClose}>
//         <DialogTitle>
//           {dialog.type === "accept" ? "Accept Investors" : "Deny Investors"}
//         </DialogTitle>
//         <DialogContent>
//           Are you sure you want to {dialog.type} the selected investors?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDialogClose}>Cancel</Button>
//           <Button onClick={() => handleAction(dialog.type)} color="primary">
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//       >
//         <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.type}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };

// export default InvestorApproval;
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Container,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import axios from "axios";

const InvestorApproval = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({ role: "", organisation: "" });
  const [filterOptions, setFilterOptions] = useState({ roles: [], organisations: [] });
  const [loading, setLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dialog, setDialog] = useState({ open: false, type: "", rowIds: [] });
  const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "success" });
  const [actionLoading, setActionLoading] = useState(false);

  // Fetch data and populate filter options
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("https://newbackend.elephant-tank.com/api/investor_data/", {
          headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
        });

        const filteredInvestors = response.data.filter((investor) => !investor.admin_approval);
        const roles = [...new Set(filteredInvestors.map((item) => item.role))];
        const organisations = [...new Set(filteredInvestors.map((item) => item.organisation))];

        setData(filteredInvestors);
        setFilteredData(filteredInvestors);
        setFilterOptions({ roles, organisations });
      } catch (error) {
        console.error("Error fetching data:", error);
        setSnackbar({ open: true, message: "Error fetching data.", type: "error" });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDialogOpen = (type, rowIds) => setDialog({ open: true, type, rowIds });
  const handleDialogClose = () => setDialog({ open: false, type: "", rowIds: [] });

  const handleAction = async (action) => {
    setActionLoading(true);
    try {
      const { rowIds } = dialog;
      const payload = { ivestors: rowIds };

      await axios.post("https://newbackend.elephant-tank.com/api/approve_investor/", payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
      });

      Swal.fire({
        title: `Investors ${action}ed successfully.`,
        icon: "success",
        confirmButtonText: "OK",
      });

      const updatedData = data.filter((row) => !rowIds.includes(row.id));
      setData(updatedData);
      setFilteredData(updatedData);
    } catch (error) {
      console.error(`Error ${action}ing investors:`, error);
      Swal.fire({
        title: `Failed to ${action} investors.`,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setActionLoading(false);
      handleDialogClose();
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const resetFilters = () => {
    setFilters({ role: "", organisation: "" });
  };

  useEffect(() => {
    const applyFilters = () => {
      let filtered = data;

      if (filters.role) filtered = filtered.filter((item) => item.role === filters.role);
      if (filters.organisation)
        filtered = filtered.filter((item) => item.organisation === filters.organisation);

      setFilteredData(filtered);
    };

    applyFilters();
  }, [filters, data]);

  const columns = [
    { field: "full_name", headerName: "Name", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "role", headerName: "Role", width: 150 },
    { field: "organisation", headerName: "Organisation", width: 180 },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={() => handleDialogOpen("accept", [params.row.id])}
          >
            Approve
          </Button>
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => handleDialogOpen("deny", [params.row.id])}
          >
            Deny
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Container sx={{ mt: 8 }}>
      <Box sx={{ mb: 4, textAlign: "center" }}>
        <Typography variant="h4" gutterBottom>
          Investor Approval
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Review and approve or deny pending investor applications.
        </Typography>
      </Box>

      <Card sx={{ mb: 4, p: 2 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel>Role</InputLabel>
                <Select
                  name="role"
                  value={filters.role}
                  onChange={handleFilterChange}
                  label="Role"
                >
                  <MenuItem value="">All</MenuItem>
                  {filterOptions.roles.map((role) => (
                    <MenuItem key={role} value={role}>
                      {role}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel>Organisation</InputLabel>
                <Select
                  name="organisation"
                  value={filters.organisation}
                  onChange={handleFilterChange}
                  label="Organisation"
                >
                  <MenuItem value="">All</MenuItem>
                  {filterOptions.organisations.map((org) => (
                    <MenuItem key={org} value={org}>
                      {org}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Button variant="outlined" fullWidth onClick={resetFilters}>
                Reset Filters
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Box sx={{ height: 500 }}>
        {loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <DataGrid
            rows={filteredData}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 20]}
            checkboxSelection
            disableSelectionOnClick
            onSelectionModelChange={(ids) => setSelectedRows(ids)}
            getRowId={(row) => row.id}
          />
        )}
      </Box>

      <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <Button
          variant="contained"
          color="success"
          onClick={() => handleDialogOpen("accept", selectedRows)}
          disabled={selectedRows.length === 0}
        >
          Approve Selected
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => handleDialogOpen("deny", selectedRows)}
          disabled={selectedRows.length === 0}
        >
          Deny Selected
        </Button>
      </Box>

      <Dialog open={dialog.open} onClose={handleDialogClose}>
        <DialogTitle>
          {dialog.type === "accept" ? "Approve Investors" : "Deny Investors"}
        </DialogTitle>
        <DialogContent>
          Are you sure you want to {dialog.type} the selected investors?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button
            onClick={() => handleAction(dialog.type)}
            color="primary"
            disabled={actionLoading}
          >
            {actionLoading ? <CircularProgress size={24} /> : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.type}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default InvestorApproval;